<template>
  <resource-search
    search-context="watchlist"
    :resource-props="{
      'show-user': true
    }"
    :allow-all-tags="true"
    :use-tag-text-in-url="true"
    :has-tags="false"
  >
    <template v-slot:header>
      <div class="flex items-center">
        <nice-icon
          icon="eye"
          class="mr3 has-text-primary search-header-icon"
        ></nice-icon>
        <heading size="medium" :spacing-bottom="false">Watchlist</heading>
      </div>
    </template>

    <!-- <template v-slot:searchBelow>
    <div class="mt5">
      <heading size="small">Users you watch</heading>
      <user
      v-for="user in $user.watching"
      :key="user.id"
      :user="user"
      size="small"
      is-link
      class="mb3"
      show-name></user>
    </div>
  </template> -->

    <template v-slot:empty>
      <b-message>
        Seems like you don't watch anyone yet..
      </b-message>
    </template>
  </resource-search>
</template>

<script>
import ResourceSearch from "@/components/resource/Search.vue";

export default {
  components: {
    ResourceSearch
  },

  watch: {
    initAndContext: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.$wait.start("loading.watchlist");
          this.$store.commit("watchlist/default/SET_PAGE", 0);
          await this.$store.dispatch("watchlist/default/fetchResources");
          this.$wait.end("loading.watchlist");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
